import { LevelUpContextInitialState } from '.';
import { LEVELUP_ACTIONS } from './actions';

export const levelUpContextReducer = (state = LevelUpContextInitialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case LEVELUP_ACTIONS.SET_LEVEL_UP_DETAILS: {
      return {
        ...state,
        levelUpDetails: payload,
      };
    }
    case LEVELUP_ACTIONS.SET_IS_MANAGER_FLAG: {
      return {
        ...state,
        isLoggedInEmployeeManager: payload,
      };
    }

    case LEVELUP_ACTIONS.UPDATE_COMPETENCY_TARGET_DATE: {
      const { jobFunctionId, jobRoleId, competencyId, subCompetencyId, targetPeriodStart } = payload;

      /* TODO: handle sub competency date change */
      const updatedJobCompetencies = state.levelUpDetails.jobCompetencies.map((jCObj) => {
        if (jCObj.jobFunction.uuid === jobFunctionId && jCObj.jobRole.uuid === jobRoleId) {
          return {
            ...jCObj,
            competencies: jCObj.competencies.map((cObj) => {
              if (cObj.competencyId === competencyId) {
                return {
                  ...cObj,
                  targetPeriodStart,
                };
              }
              return cObj;
            }),
          };
        }
        return jCObj;
      });

      return {
        ...state,
        levelUpDetails: {
          ...state.levelUpDetails,
          jobCompetencies: updatedJobCompetencies,
        },
      };
    }

    case LEVELUP_ACTIONS.UPDATE_COMPETENCY_PROGRESS_STATUS: {
      const { jobFunctionId, jobRoleId, competencyId, subCompetencyId, status } = payload;

      const updatedJobCompetencies = state.levelUpDetails.jobCompetencies.map((jCObj) => {
        if (jCObj.jobFunction.uuid === jobFunctionId && jCObj.jobRole.uuid === jobRoleId) {
          return {
            ...jCObj,
            competencies: jCObj.competencies.map((cObj) => {
              if (cObj.competencyId === competencyId) {
                return {
                  ...cObj,
                  status,
                };
              }
              return cObj;
            }),
          };
        }
        return jCObj;
      });

      return {
        ...state,
        levelUpDetails: {
          ...state.levelUpDetails,
          jobCompetencies: updatedJobCompetencies,
        },
      };
    }

    case LEVELUP_ACTIONS.OPEN_ROLE_SELECTION_MODAL: {
      return {
        ...state,
        isRoleSelectionModalOpen: true,
        isNewRoleSelection: payload?.isNewRoleSelection ?? false,
      };
    }
    case LEVELUP_ACTIONS.CLOSE_ROLE_SELECTION_MODAL: {
      return {
        ...state,
        isRoleSelectionModalOpen: false,
      };
    }

    case LEVELUP_ACTIONS.SET_ONE_ON_ONE_INSTANCE_DETAILS: {
      return {
        ...state,
        checkInInstanceId: payload.checkInInstanceId,
        checkInParentId: payload.checkInParentId,
        filterEmpIds: payload.filterEmpIds,
      };
    }

    case LEVELUP_ACTIONS.SET_SELECTED_ROLE: {
      return {
        ...state,
        selectedOption: payload.selectedOption,
      };
    }

    case LEVELUP_ACTIONS.SET_ROLE_OPTIONS: {
      return {
        ...state,
        selectOptions: payload.selectOptions,
      };
    }

    default:
      return state;
  }
};
